import Marionette from 'backbone.marionette';
import memberDetailLayoutTmpl from '../templates/member_detail_layout.tpl';
export default Marionette.LayoutView.extend({
  template: memberDetailLayoutTmpl,
  regions: {
    detailRegion: "#detail-region",
    contributorsRegion: "#contributors-region",
    committeesRegion: "#committees-region",
    billsRegion: "#bills-region",
    votesRegion: "#votes-region"
  }
});